<script lang="ts">
	import type { PageData } from './$types';
	import MeetingHeader from '$lib/components/meetings/MeetingHeader.svelte';
	import MeetingsList from '$lib/components/meetings/MeetingsList.svelte';

	export let data: PageData;
</script>

<svelte:head>
	<title>Meeting Minutes {data.year} | Desert Shores Amateur Radio Club</title>
	<meta
		name="description"
		content="Meeting minutes from {data.year} for the Desert Shores Amateur Radio Club."
	/>
</svelte:head>

<div class="mx-auto max-w-4xl">
	<div class="mb-8">
		<nav class="flex" aria-label="Breadcrumb">
			<ol class="flex items-center space-x-4">
				<li>
					<a
						href="/meetings"
						class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
					>
						Meeting Minutes
					</a>
				</li>
				<li class="flex items-center">
					<svg class="h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
						<path
							fill-rule="evenodd"
							d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
							clip-rule="evenodd"
						/>
					</svg>
					<span class="ml-4 text-gray-700 dark:text-gray-300">{data.year}</span>
				</li>
			</ol>
		</nav>

		<MeetingHeader title="{data.year} Meeting Minutes" />
	</div>

	<MeetingsList
		meetings={data.meetings || []}
		emptyMessage="Meeting minutes for {data.year} will be posted here as they become available."
		showYear={false}
	/>
</div>
